import React from 'react';
import { useIntl } from 'react-intl';
import Order from '../../../../types/order/Order';
import { useSanitizedOrder } from '../hooks/useOrders';
import OrderWrapper from './OrderWrapper';

interface OrderInListProps {
  order: Order;
}

const OrderInList = ({ order }: OrderInListProps) => {
  const { locale } = useIntl();
  const { order: sanitizedOrder } = useSanitizedOrder(
    order.id,
    locale,
    'order_list_api_failure',
  );

  return (
    <OrderWrapper partialOrderData={order} fullOrderData={sanitizedOrder} />
  );
};

export default OrderInList;
